//@libs
import PropTypes from "prop-types";

import { FaTrashAlt } from "react-icons/fa";
//@components
import IconButton from "./";

const DeleteIconButton = ({
  title = "Eliminar",
  customIcon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={customIcon || <FaTrashAlt className="text-red-600 text-lg hover:scale-110 transition-transform" />}
      {...props}
    />
  );
};

DeleteIconButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default DeleteIconButton;
